"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSnackbar = exports.SnackbarProvider = exports.SnackbarContext = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Close_1 = __importDefault(require("@mui/icons-material/Close"));
var Alert_1 = __importDefault(require("@mui/material/Alert"));
var IconButton_1 = __importDefault(require("@mui/material/IconButton"));
var Snackbar_1 = __importDefault(require("@mui/material/Snackbar"));
var react_1 = require("react");
var useSnackbar_module_scss_1 = __importDefault(require("./useSnackbar.module.scss"));
var AUTO_HIDE_DURATION = 6000;
exports.SnackbarContext = (0, react_1.createContext)({});
var SnackbarProvider = function (_a) {
    var children = _a.children, snackbarProps = __rest(_a, ["children"]);
    var _b = (0, react_1.useState)(), message = _b[0], setMessage = _b[1];
    var _c = (0, react_1.useState)(false), open = _c[0], setOpen = _c[1];
    var _d = (0, react_1.useState)(), alertType = _d[0], setAlertType = _d[1];
    var handleClose = function (_event, reason) {
        if (reason === 'clickaway')
            return;
        setOpen(false);
    };
    var context = {
        showSnackbar: function (message, alertType) {
            setMessage(message);
            setOpen(true);
            setAlertType(alertType || 'success');
        },
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(exports.SnackbarContext.Provider, __assign({ value: context }, { children: children })), (0, jsx_runtime_1.jsx)(Snackbar_1.default, __assign({ "aria-label": 'status message', autoHideDuration: AUTO_HIDE_DURATION }, snackbarProps, { open: open, onClose: handleClose }, { children: (0, jsx_runtime_1.jsxs)(Alert_1.default, __assign({ classes: { root: useSnackbar_module_scss_1.default.alert }, severity: alertType }, { children: [message, (0, jsx_runtime_1.jsx)(IconButton_1.default, __assign({ classes: { root: useSnackbar_module_scss_1.default.closeButton }, "aria-label": 'close', onClick: handleClose, size: 'large' }, { children: (0, jsx_runtime_1.jsx)(Close_1.default, {}) }))] })) }))] }));
};
exports.SnackbarProvider = SnackbarProvider;
function useSnackbar() {
    return (0, react_1.useContext)(exports.SnackbarContext);
}
exports.useSnackbar = useSnackbar;
